import type React from 'react';
import { Section, SectionHeader } from '@/components/ui/Section';
import { HandDrawnQuote } from '@/components/ui/decorative';

export const SocialProof: React.FC = () => {
  return (
    <Section className="bg-cream-paper">
      <SectionHeader
        badge="Proof"
        title="Join executives who've already moved the needle"
        description="Peer-validated by C-suite leaders in B2B SaaS and tech."
      />

      <figure className="max-w-3xl mx-auto text-center">
        {/* Top ochre rule */}
        <div className="flex justify-center mb-10">
          <div className="h-px w-24 bg-aged-brass/40" aria-hidden="true" />
        </div>

        {/* Quote dingbat */}
        <HandDrawnQuote
          className="mx-auto mb-8 w-16 h-14 opacity-60"
          aria-hidden="true"
        />

        {/* Pull quote */}
        <blockquote className="font-display text-2xl md:text-[2rem] lg:text-[2.25rem] leading-[1.25] tracking-tight italic text-charcoal max-w-[36ch] mx-auto">
          &ldquo;I went from zero articles this year to three a month&mdash;without a
          subscription. The ROI on my time is undeniable.&rdquo;
        </blockquote>

        {/* Author byline */}
        <figcaption className="mt-10">
          <div className="font-display text-base font-semibold text-charcoal">
            Sarah Jenkins
          </div>
          <div className="smcp text-[13px] text-muted-warm mt-1">
            CSO, Mid-Market SaaS
          </div>
        </figcaption>
      </figure>

      {/* 3-stat trio */}
      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-12 text-center border-t border-aged-brass/20 pt-12 max-w-4xl mx-auto">
        <div>
          <div className="font-display font-bold tabular-nums text-bottle-green mb-2 tracking-tight leading-none text-[clamp(2.5rem,4vw+1rem,3.75rem)]">3&ndash;5&times;</div>
          <div className="smcp text-muted-warm font-medium text-sm">Publication frequency</div>
        </div>
        <div>
          <div className="font-display font-bold tabular-nums text-bottle-green mb-2 tracking-tight leading-none text-[clamp(2.5rem,4vw+1rem,3.75rem)]">8 hrs</div>
          <div className="smcp text-muted-warm font-medium text-sm">Weekly time recovered</div>
        </div>
        <div>
          <div className="font-display font-bold tabular-nums text-bottle-green mb-2 tracking-tight leading-none text-[clamp(2.5rem,4vw+1rem,3.75rem)]">500+</div>
          <div className="smcp text-muted-warm font-medium text-sm">Executives trust us</div>
        </div>
      </div>
    </Section>
  );
};
